import React from 'react';
import Conditions from './fields/Conditions';

const IfElseStep = () => <Conditions />;

export default IfElseStep;
